import { useNavigate } from "react-router-dom";
import BackButton from "../../common/components/BackButton";
import FormBuilder from "../../common/components/formInputs/FormBuilder";
import useComponents from "../../common/hooks/pages/useComponents";
import useIncidents from "../../common/hooks/pages/useIncidents";
import { useMutation, useQuery } from "react-query";
import { useEffect } from "react";
function getFormInputs(component = {}, data, records, status) {
  const { name, inciStatus, message, Affected, notification, remind } =
    component;
  const formInputs = [
    {
      type: "text",
      name: "name",
      label: "Incident name",
      placeholder: "Incident name",
      baseinfo: "This incident will be posted to page Demo",
      validation: {
        required: "Incident name is required",
      },
      defaultValue: name,
    },
    {
      type: "checkbox",
      name: "incident",
      label: "Backfill an incident that happened in the past",
    },
    {
      type: "select",
      name: "status",
      label: "Status",
      placeholder: "Incident status",
      validation: {
        required: "Incident status is required",
      },
      defaultValue: inciStatus,
      options: data?.data?.incidentStatusTypes?.map((data) => ({
        label: data.label,
        value: data._id,
      })),
    },
    {
      type: "textarea",
      name: "message",
      label: "Message",
      placeholder: "Message",
      defaultValue: message,
    },
    {
      type: "affectedItems",
      name: "affectedComponents",
      label: "Affected Components",
      records: records?.data?.components?.map((data) => ({
        label: data.name,
        value: data._id,
      })),
      defaultValue: Affected,
      options: status?.data?.componentStatusTypes?.map((data) => ({
        label: data.label,
        value: data._id,
      })),
    },
    {
      primaryLabel: "Notifications",
      type: "checkbox",
      name: "notification",
      label: "Send Notifications",
      defaultValue: notification,
    },
    {
      primaryLabel: "Long running incident reminders",
      type: "remind",
      name: "remind",
      label: "Remind admins to update an incident",
      defaultValue: remind,
      group: [
        {
          type: "checkbox",
          name: "Default",
          label: "Send reminders to all admins after 3, 6, 12, and 24 hours.",
        },
      ],
    },
  ];
  const result = records?.data?.components;
  //return { formInputs: formInputs, records: result, status: status };
  return formInputs;
}

function IncidentForm({ onSubmit, isSubmitting, component, id }) {
  const navigate = useNavigate();
  const { getIncidentStatusTypes } = useIncidents();
  const { getComponents, getComponentStatusTypes } = useComponents();

  const {
    mutate: getIncidentStatus,
    data,
    isLoading: isCreating,
  } = useMutation({
    mutationFn: getIncidentStatusTypes,
    onSuccess: (res) => {},
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating component!";
    },
  });

  const {
    mutate: get_Components,
    data: records,
    isLoading: isCreate,
  } = useMutation({
    mutationFn: getComponents,
    onSuccess: (res) => {},
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating component!";
    },
  });

  const {
    mutate: getComponentStatus,
    data: status,
    isLoading: isCreates,
  } = useMutation({
    mutationFn: getComponentStatusTypes,
    onSuccess: (res) => {},
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating component!";
    },
  });

  useEffect(() => {
    getIncidentStatus();
    get_Components();
    getComponentStatus();
  }, []);

  return (
    <div>
      <div className="flex justify-between items-center pb-8 border-b">
        <div className="text-2xl font-bold">Add Incident</div>
        <BackButton onClick={() => navigate("/incidents")}>
          Back to Incidents
        </BackButton>
      </div>
      <FormBuilder
        formInputs={getFormInputs(component, data, records, status)}
        options={{ records: records?.data?.components, status }}
        submitButtonLabel={`${id ? "Save" : "Create"} Incident`}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        submitBtnContainerCls="!w-fit"
      />
    </div>
  );
}

export default IncidentForm;
